import { translated } from './types'
import type { ProductDetail, ProductInventoryRef } from './types'

/** Inventory's limit on a SKU. A longer one, or none, is never sent. */
const SKU_MAX_LENGTH = 100

/**
 * The rows of a product inventory keeps as stock items.
 *
 * The server's `sellableRows`, mirrored: several variants are the items and the
 * parent is only a grouping — it carries every variant's SKU joined — while a
 * product sold one way is its own item. One variant alone is legacy data the
 * save never writes, and counts as sold one way.
 */
export function inventoryRefsOf(product: ProductDetail): ProductInventoryRef[] {
  const name = translated(product.name)

  if (product.children.length > 1) {
    return product.children.map((variant) => ({
      id: variant.id,
      kind: 'variant',
      label:
        (variant.productAttributes ?? []).map((attribute) => attribute.value).join(' / ') ||
        variant.sku ||
        name,
      sku: variant.sku ?? '',
    }))
  }

  return [{ id: product.id, kind: 'product', label: name, sku: product.sku ?? '' }]
}

/** Whether the server will send this row at all. Retrying one it skips does nothing. */
export function canSendToInventory(ref: ProductInventoryRef): boolean {
  const sku = ref.sku.trim()

  return sku.length > 0 && sku.length <= SKU_MAX_LENGTH
}
